import React from "react";
import moment from "moment";
import { Button, SimpleGrid, Text, Title } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";

import { track } from "../utils/analytics";

const PayrollReportForm: React.FC = () => {
  // Mantine 8 switched @mantine/dates to string values ("YYYY-MM-DD HH:mm:ss")
  // instead of Date objects, so hold the picker state as strings and convert
  // only where an ISO timestamp is needed.
  const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
  const [start, setStart] = React.useState<string | null>(
    moment().startOf("month").format(DATE_FORMAT)
  );
  const [end, setEnd] = React.useState<string | null>(
    moment().endOf("month").format(DATE_FORMAT)
  );

  const generateReport = () => {
    if (start === null || end === null) return;

    track("report_generated", {
      report: "payroll",
      period_days: Math.round(moment(end).diff(moment(start), "days", true)),
    });

    window.open(
      `${window.location.origin}/app-reports/payroll?start=${moment(
        start
      ).toISOString()}&end=${moment(end).toISOString()}`,
      "payroll-report",
      "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1000,height=600"
    );
  };

  return (
    <>
      <Title mb="sm" order={2}>
        Payroll Report
      </Title>
      <Text size="sm" mb="sm">
        With the Payroll Report, you'll be able to select a specific pay period
        by setting the start and end dates. Once these dates are determined, the
        system will compile all relevant information regarding the employee's
        work shifts, as well as the number of rackets they have strung during
        this timeframe. This comprehensive report aids in ensuring accurate and
        efficient payroll management, tailored specifically to the unique
        operations of your tennis shop.
      </Text>
      <SimpleGrid cols={2} mb="sm">
        <DateTimePicker
          label="Pay Period Start"
          valueFormat="MMMM D, YYYY hh:mm A"
          value={start}
          onChange={setStart}
          maxDate={end !== null ? end : undefined}
        />
        <DateTimePicker
          label="Pay Period End"
          valueFormat="MMMM D, YYYY hh:mm A"
          value={end}
          onChange={setEnd}
          minDate={start !== null ? start : undefined}
        />
      </SimpleGrid>
      <Button id="btn-generate-payroll-report" onClick={generateReport}>
        Generate Report
      </Button>
    </>
  );
};

export default PayrollReportForm;
